import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect } from 'react';
const CompanyContext = createContext(undefined);
const STORAGE_KEY = 'selectedCompanyId';
export const CompanyProvider = ({ children }) => {
    const [selectedCompanyId, setSelectedCompanyId] = useState(() => {
        // Initialize from localStorage - will be set by header based on user role
        const stored = localStorage.getItem(STORAGE_KEY);
        return stored || null;
    });
    // Persist to localStorage whenever it changes
    useEffect(() => {
        if (selectedCompanyId) {
            localStorage.setItem(STORAGE_KEY, selectedCompanyId);
        }
        else {
            localStorage.removeItem(STORAGE_KEY);
        }
    }, [selectedCompanyId]);
    return (_jsx(CompanyContext.Provider, { value: { selectedCompanyId, setSelectedCompanyId }, children: children }));
};
export const useCompanyContext = () => {
    const context = useContext(CompanyContext);
    if (!context) {
        throw new Error('useCompanyContext must be used within a CompanyProvider');
    }
    return context;
};
